<h5 class="pt-3 mt-1 mb-0 text-start faq-section-title">{{ faqSection.DisplayText }}</h5>
<div class="mt-3">
  <div ngbAccordion>
    <ng-container *ngFor="let faqSectionCard of faqSection.SectionItems">
      <ng-container *ngIf="faqSectionCard">
        <div ngbAccordionItem [collapsed]="true">
          <h2 ngbAccordionHeader class="mt-0">
            <button ngbAccordionButton data-testid="accordion-button" class="faq-section-card-title">
              {{ faqSectionCard.DisplayText }}
            </button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <p class="faq-section-card-description mb-0" [innerHtml]="faqSectionCard.Description | safeHtml"></p>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
